import { SystemCurrency } from '@okletsplay/core';

export const PAYMENT_ACCOUNTS_DISPLAY_ORDER: Record<string, number> = {
  [SystemCurrency.USDT]: 0,
  [SystemCurrency.OKLP]: 1,
};

export const PAYMENT_ACCOUNT_LAST_ORDER = +Infinity;
